import React from 'react'

export const CreateKeysAddressNote = ({ networkBranch }) => {
  return (
    <p className={`key-CreateKeysAddressNote key-CreateKeysAddressNote-${networkBranch}`}>
      <i className={`key-CreateKeysAddressNote_InfoIcon key-CreateKeysAddressNote_InfoIcon-${networkBranch}`} />
      The entered address will be displayed as Unconfirmed and will be used if you don't have Registered Address(es) in{' '}
      <a href="https://alltra.global/" target="_blank" rel="noopener noreferrer">
        ALLTRA DApp
      </a>
      . You have to use ALLTRA to register and confirm your address(es).
    </p>
  )
}
